import Vue from 'vue';
import Router from 'vue-router';
// NOTE: not found
import NotFound from '@/components/NotFound';
// NOTE: Signing
import Signing from '@/components/Signing';
import SignIn from '@/components/signing/SignIn';
import PwdReset from '@/components/signing/PwdReset';
import PwdResetConfirm from '@/components/signing/PwdResetConfirm';
import EmailInvalid from '@/components/signing/EmailInvalid';
import PwdTokenValid from '@/components/signing/PwdTokenValid';
// NOTE: Admin
import Admin from '@/components/Admin';
import Bookings from '@/components/admin/Bookings';
import BookingsDetail from '@/components/admin/BookingsDetail';
import Hotels from '@/components/admin/Hotels';
import HotelsDetail from '@/components/admin/HotelsDetail';
import HotelsDetailInfo from '@/components/admin/hotels/HotelsDetailInfo';
import HotelsPermission from '@/components/admin/hotels/HotelsPermission';
import HotelsBookings from '@/components/admin/hotels/HotelsBookings';
import Doorlocks from '@/components/admin/Doorlocks';
import DoorlocksDetail from '@/components/admin/DoorlocksDetail';
import DoorlocksDetailInfo from '@/components/admin/doorlocks/DoorlocksDetailInfo';
import DoorlocksMobileKey from '@/components/admin/doorlocks/DoorlocksMobileKey';
import DoorlockBookings from '@/components/admin/doorlocks/DoorlockBookings';
// import DoorlockLogsList from '@/components/admin/doorlocks/DoorlockLogsList';
import DoorlocksLogs from '@/components/admin/doorlocks/DoorlocksLogs';
import Users from '@/components/admin/Users';
import UsersDetail from '@/components/admin/UsersDetail';
import Staffs from '@/components/admin/Staffs';
import StaffsDetail from '@/components/admin/StaffsDetail';
import Admins from '@/components/admin/Admins';
import AdminsDetail from '@/components/admin/AdminsDetail';
import Domains from '@/components/admin/Domains';
import DomainsDetail from '@/components/admin/DomainsDetail';
import AuditLogs from '@/components/admin/AuditLogs';
import AuditLogsDetail from '@/components/admin/AuditLogsDetail';
import api from '../api';

Vue.use(Router);

/*
 * TODO: navigation guard
 * 1. devtool에서 값을 임의로 변경할 경우??? (staff -> admin)
 * 2. 잘못된 경로, 혹은 유저 타입에 맞지 않는 경로에 접근시
*/
function isAuthorization() {
  if (localStorage.getItem('apikey') === '') {
    console.log(1);
    return false;
  } else if (localStorage.getItem('apikey') === null) {
    console.log(2);
    return false;
  } else if (localStorage.getItem('apikey') === undefined) {
    console.log(3);
    return false;
  }
  return true;
}

function requireAuth(to, from, next) {
  if (!isAuthorization()) {
    console.log('admin directory');
    next({
      name: 'signIn',
    });
  } else {
    next();
  }
}

/**
 * @description password reset token validation
 */
function requirePasswordToken(to, from, next) {
  if (from.params.token) {  // NOTE: email 링크로 진입시
    api.resetPasswordToken(from.params.token)
    .then((result) => {
      if (result.status === 200) {
        next();
      }
    })
    .catch((err) => {
      console.log(err);
      next({ name: 'emailInvalid' });
    });
  } else {                  // NOTE: url을 직접입력하여 패스워드 리셋페이지로 접근시 차단
    next({ name: 'emailInvalid' });
  }
}

function isDomainType(to, from, next) {
  if (localStorage.getItem('domain_type') === 'root') {
    next();
  } else {
    next({ name: 'hotels' });
  }
}

/**
 * @description domain_type이 root가 아니면 메뉴로의 이동이 안되므로 url을 찍어서 들어가게 되는데
 * 그럴경우 이전(from)의 정보가 없이 페이지가 새로 렌더링된다. 따라서 이전페이지로 갈수 가 없으므로
 * hotel로 강제이동
 */

// TODO: account(admin, staff, user, ...)삭제후 목록화면으로 리다이렉트 된 후 브라우저의 뒤로 가기가 작동하면 없는
// 화면으로 나오는 것을 방지 해야 한다. 네비게이션 가드를 이용해서 이동 전 해당 account의 유무를 먼저 판단해야 한다.
// function existAccount() {
// }

const routes = [
  // NOTE: not found
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
  {
    path: '/',
    component: Signing,
    children: [
      {
        path: '',
        name: 'signIn',
        component: SignIn,
      },
      {
        path: 'pwd-reset',
        name: 'pwdReset',
        component: PwdReset,
      },
      {
        path: 'pwd-reset-confirm/',
        name: 'pwdResetConfirm',
        component: PwdResetConfirm,
        beforeEnter: requirePasswordToken,
      },
      {
        path: 'password_reset/:token',
        name: 'pwdTokenValid',
        component: PwdTokenValid,
      },
      {
        path: 'email-invalid',
        name: 'emailInvalid',
        component: EmailInvalid,
      },
    ],
  },
  {
    path: '/',
    component: Admin,
    beforeEnter: requireAuth,
    children: [
      // NOTE: List
      {
        path: 'bookings',
        name: 'bookings',
        component: Bookings,
      },
      // NOTE: Detail
      {
        path: 'bookings/:id',
        name: 'bookingsDetail',
        component: BookingsDetail,
      },
      // NOTE: List
      {
        path: 'hotels',
        name: 'hotels',
        component: Hotels,
      },
      // NOTE: Detail
      {
        path: 'hotels/:id',
        component: HotelsDetail,
        children: [
          {
            path: 'information',
            name: 'hotelsDetailInfo',
            component: HotelsDetailInfo,
          },
          {
            path: 'permissions',
            name: 'hotelsPermission',
            component: HotelsPermission,
          },
          {
            path: 'bookings',
            name: 'hotelsBookings',
            component: HotelsBookings,
          },
        ],
      },
      // NOTE: List
      {
        path: 'doorlocks',
        name: 'doorlocks',
        component: Doorlocks,
      },
      // NOTE: Detail
      {
        path: 'doorlocks/:id/hotels/:hotel_id',
        component: DoorlocksDetail,
        children: [
          {
            path: 'information',
            name: 'doorlocksDetailInfo',
            component: DoorlocksDetailInfo,
          },
          {
            path: 'mobilekeys',
            name: 'doorlocksMobileKey',
            component: DoorlocksMobileKey,
          },
          {
            path: 'doorlocklogs',
            name: 'doorlockLogs',
            component: DoorlocksLogs,
          },
          {
            path: 'bookings',
            name: 'doorlockBookings',
            component: DoorlockBookings,
          },
        ],
      },
      // NOTE: List
      {
        path: 'users',
        name: 'users',
        component: Users,
      },
      // NOTE: Detail
      {
        path: 'users/:id',
        name: 'usersDetail',
        component: UsersDetail,
      },
      // NOTE: List
      {
        path: 'staffs',
        name: 'staffs',
        component: Staffs,
      },
      // NOTE: Detail
      {
        path: 'staffs/:id',
        name: 'staffsDetail',
        component: StaffsDetail,
      },
      // NOTE: List
      {
        path: 'admins',
        name: 'admins',
        component: Admins,
      },
      // NOTE: Detail
      {
        path: 'admins/:id',
        name: 'adminsDetail',
        component: AdminsDetail,
      },
      // NOTE: List
      {
        path: 'domains',
        name: 'domains',
        component: Domains,
        beforeEnter: isDomainType,
      },
      // NOTE: Detail
      {
        path: 'domains/:id',
        name: 'domainsDetail',
        component: DomainsDetail,
        beforeEnter: isDomainType,
      },
      // NOTE: List
      {
        path: 'auditLogs',
        name: 'auditLogs',
        component: AuditLogs,
      },
      // NOTE: Detail
      {
        path: 'auditLogs/:id',
        name: 'auditLogsDetail',
        component: AuditLogsDetail,
      },
    ],
  },
];

const router = new Router({
  mode: 'history',
  base: '/',
  routes,
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js